import { ReactNode } from 'react';
import { TextBlock } from '../../Atoms/Text';
import { DetailViewCard } from '../CardWithTitle';
import { ComponentSpinner } from '../Loading/ComponentSpinner';
import { ActiveFlagged, activeFirst, countedTitle, moreRecordsNote, RecordSection } from './relatedRecords';
import { RelatedRecordsColumn, RelatedRecordsTable } from './RelatedRecordsTable';

export interface RelatedRecordsCardProps<T extends ActiveFlagged> {
  title: string;
  count: number | null | undefined;
  section: RecordSection<T> | undefined;
  emptyText: string;
  testId: string;
  recordKey: (record: T) => string;
  columns: RelatedRecordsColumn<T>[];
  openTitle: string;
  onOpen: (record: T) => void;
  cardActions?: ReactNode;
}

export function RelatedRecordsCard<T extends ActiveFlagged>({
  title,
  count,
  section,
  emptyText,
  testId,
  recordKey,
  columns,
  openTitle,
  onOpen,
  cardActions
}: RelatedRecordsCardProps<T>) {
  const note = section && moreRecordsNote(section);

  return (
    <DetailViewCard
      childrenWrapperClass="overflow-x-auto"
      cardActions={cardActions}
      title={countedTitle(title, count)}>
      <>
        {!section && (
          <div className="mt-4">
            <ComponentSpinner />
          </div>
        )}
        {section && section.records.length === 0 && <div className="text-center">{emptyText}</div>}
        {section && section.records.length > 0 && (
          <RelatedRecordsTable
            testId={testId}
            records={activeFirst(section.records)}
            recordKey={recordKey}
            columns={columns}
            openTitle={openTitle}
            onOpen={onOpen}
          />
        )}
        {note && (
          <TextBlock
            className="mt-3 px-2"
            color="grey6"
            size="sm">
            {note}
          </TextBlock>
        )}
      </>
    </DetailViewCard>
  );
}
